var React = require('react');

function TooltipArrowInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.8608 6.83868C10.262 8.74754 7.32646 8.74754 5.7277 6.83868L0 0L17.5885 0L11.8608 6.83868Z","fill":"#000"}));
}

TooltipArrowInline.defaultProps = {"width":"18","height":"9","viewBox":"0 0 18 9","fill":"none"};

module.exports = TooltipArrowInline;

TooltipArrowInline.default = TooltipArrowInline;
